import {
  SURVOL_CONTOUR_DEFAUTS,
  SURVOL_CONTOUR_LIMITES,
} from "./scene_hover_settings.js";

const ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT = 24;

export const REGLAGES_MODE_LECTURE_PROJET_DEFAUTS = Object.freeze ({
  hover_transition_ms : 1000,
  survol_obj_scale_pct : 3,
  survol_contour_couleur : SURVOL_CONTOUR_DEFAUTS.couleur,
  survol_contour_epaisseur : SURVOL_CONTOUR_DEFAUTS.epaisseur,
  survol_contour_opacite : SURVOL_CONTOUR_DEFAUTS.opacite,
  nouvel_essai_contour_duree_s : 2,
  zoom_carte_zoom_delai_ms : 0,
  zoom_carte_dezoom_delai_ms : 0,
  zoom_carte_duree_ms : 1200,
  delai_affichage_obj_s : 1,
  audio_general_volume_pct : 100,
  voix_volume_pct : 100,
  fade_masque_in_ms : 420,
  fade_masque_out_ms : 320,
  fade_masque_ms : 2000,
  reveil_objet_duree_ms : 1200,
  reveil_objet_scale_pct : 3.5,
  bulle_click_duree_ms : 500,
  bulle_click_scale_pct : 10,
  zoom_alternatif_cadre_epaisseur_haut : ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT,
  zoom_alternatif_cadre_epaisseur_droite : ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT,
  zoom_alternatif_cadre_epaisseur_bas : ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT,
  zoom_alternatif_cadre_epaisseur_gauche : ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT,
  zoom_alternatif_cadre_couleur : "#f6efd8",
  zoom_alternatif_cadre_ombre_active : false,
  zoom_alternatif_cadre_ombre_couleur : "#5d5d5d",
  zoom_alternatif_cadre_ombre_offset_x : 0,
  zoom_alternatif_cadre_ombre_offset_y : 0,
  zoom_alternatif_cadre_ombre_opacite : 1,
  zoom_alternatif_cadre_ombre_rotation : 0,
  zoom_alternatif_cadre_ombre_largeur_pct : 100,
  zoom_alternatif_cadre_ombre_hauteur_pct : 100,
  zoom_alternatif_cadre_ombre_arrondi : 0,
  zoom_alternatif_cadre_ombre_svg_active : false,
  zoom_alternatif_cadre_ombre_svg_couleur : "#000000",
  zoom_alternatif_cadre_ombre_svg_offset_x : 12,
  zoom_alternatif_cadre_ombre_svg_offset_y : 12,
  zoom_alternatif_cadre_ombre_svg_opacite : 0.35,
  zoom_alternatif_cadre_ombre_svg_flou : 6,
  zoom_alternatif_cadre_arriere_plan_2_active : false,
  zoom_alternatif_cadre_arriere_plan_2_couleur : "#ffffff",
  zoom_alternatif_cadre_arriere_plan_2_offset_x : 0,
  zoom_alternatif_cadre_arriere_plan_2_offset_y : 0,
  zoom_alternatif_cadre_arriere_plan_2_opacite : 1,
  zoom_alternatif_cadre_arriere_plan_2_rotation : -4,
  zoom_alternatif_cadre_arriere_plan_2_largeur_pct : 100,
  zoom_alternatif_cadre_arriere_plan_2_hauteur_pct : 100,
  zoom_alternatif_cadre_arriere_plan_2_arrondi : 0,
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_active : false,
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_couleur : "#000000",
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_x : 0,
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_y : 12,
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_opacite : 0.35,
  zoom_alternatif_cadre_arriere_plan_2_ombre_svg_flou : 12,
  zoom_alternatif_cadre_arrondi : 0,
  zoom_alternatif_focus_facteur : 2,
  zoom_alternatif_focus_offset_x : 0,
  zoom_alternatif_focus_offset_y : 0,
  zoom_alternatif_delai_lancement_s : 0,
  zoom_alternatif_masque_fade_in_ms : 1000,
  zoom_alternatif_masque_fade_out_ms : 1000,
  zoom_alternatif_interface_fade_in_ms : 300,
  zoom_alternatif_interface_fade_out_ms : 300,
  zoom_alternatif_photo_fade_in_ms : 120,
  zoom_alternatif_dezoom_offset_ms : 1000,
  zoom_alternatif_photo_fade_out_ms : 180,
  zoom_alternatif_taille_carte_jauge : 1.5,
  zoom_alternatif_taille_carte_fermeture : 1.5,
  zoom_alternatif_taille_carte_legende : 4,
  zoom_alternatif_taille_carte_non : 1.5,
  zoom_alternatif_taille_carte_oui : 1.5,
  boutons_scene_taille_carte_jauge_pct : 100,
  boutons_scene_offset_x_carte_jauge : 0,
  boutons_scene_offset_y_carte_jauge : 0,
  zoom_alternatif_offset_x_carte_jauge : 0,
  zoom_alternatif_offset_y_carte_jauge : 0,
  zoom_alternatif_offset_x_carte_fermeture : 0,
  zoom_alternatif_offset_y_carte_fermeture : 0,
  zoom_alternatif_offset_x_carte_legende : 0,
  zoom_alternatif_offset_y_carte_legende : 0,
  zoom_alternatif_offset_x_carte_non : 0,
  zoom_alternatif_offset_y_carte_non : 0,
  zoom_alternatif_offset_x_carte_oui : 0,
  zoom_alternatif_offset_y_carte_oui : 0,
  zoom_alternatif_ancrage_carte_fermeture : "gauche",
  transition_scene_fade_ms : 400,
  morphing_image_duree_s : 1,
  morphing_fondu_ms : 1000,
  morphing_fond_couleur : "#ffffff",
  morphing_stage_taille_pct : 60,
  morphing_stage_padding_rem : 1,
  morphing_stage_radius_rem : 1,
  morphing_ratio_l : 1,
  morphing_ratio_h : 1,
  morphing_bouton_ratio_l : 1,
  morphing_bouton_ratio_h : 1,
  animation_30fps_actif : false,
  jauge_visuelle : null,
  hype_recompense_carte_fond_transparent : true,
  hype_recompense_carte_couleur_fond : "#ffffff",
  hype_recompense_carte_taille_pct : 100,
  hype_recompense_carte_align_x : "centre",
  hype_recompense_carte_align_y : "centre",
  hype_recompense_carte_offset_x_pct : 0,
  hype_recompense_carte_offset_y_pct : 0,
  hype_recompense_carte_disparition_ms : 2400,
  hype_recompense_carte_fadeout_ms : 450,
  hype_recompense_scene_fond_transparent : true,
  hype_recompense_scene_couleur_fond : "#ffffff",
  hype_recompense_scene_taille_pct : 100,
  hype_recompense_scene_align_x : "centre",
  hype_recompense_scene_align_y : "centre",
  hype_recompense_scene_offset_x_pct : 0,
  hype_recompense_scene_offset_y_pct : 0,
  hype_recompense_scene_disparition_ms : 2400,
  hype_recompense_scene_fadeout_ms : 450,
});

export const REGLAGES_MODE_LECTURE_PROJET_LIMITES = Object.freeze ({
  hover_transition_ms : {min : 0, max : 3000, step : 10},
  survol_obj_scale_pct : {min : 0, max : 30, step : 0.5},
  survol_contour_epaisseur : SURVOL_CONTOUR_LIMITES.epaisseur,
  survol_contour_opacite : SURVOL_CONTOUR_LIMITES.opacite,
  nouvel_essai_contour_duree_s : {min : 0, max : 10, step : 0.1},
  zoom_carte_zoom_delai_ms : {min : 0, max : 4000, step : 10},
  zoom_carte_dezoom_delai_ms : {min : 0, max : 4000, step : 10},
  zoom_carte_duree_ms : {min : 150, max : 6000, step : 10},
  delai_affichage_obj_s : {min : 0, max : 10, step : 0.1},
  audio_general_volume_pct : {min : 0, max : 100, step : 1},
  voix_volume_pct : {min : 0, max : 100, step : 1},
  fade_masque_in_ms : {min : 0, max : 4000, step : 10},
  fade_masque_out_ms : {min : 0, max : 4000, step : 10},
  fade_masque_ms : {min : 0, max : 4000, step : 10},
  reveil_objet_duree_ms : {min : 0, max : 4000, step : 10},
  reveil_objet_scale_pct : {min : 0, max : 40, step : 0.5},
  bulle_click_duree_ms : {min : 0, max : 4000, step : 10},
  bulle_click_scale_pct : {min : 0, max : 40, step : 0.5},
  zoom_alternatif_cadre_epaisseur_haut : {min : 0, max : 240, step : 1},
  zoom_alternatif_cadre_epaisseur_droite : {min : 0, max : 240, step : 1},
  zoom_alternatif_cadre_epaisseur_bas : {min : 0, max : 240, step : 1},
  zoom_alternatif_cadre_epaisseur_gauche : {min : 0, max : 240, step : 1},
  zoom_alternatif_cadre_ombre_offset : {min : -240, max : 240, step : 1},
  zoom_alternatif_cadre_ombre_opacite : {min : 0, max : 1, step : 0.01},
  zoom_alternatif_cadre_ombre_rotation : {min : -45, max : 45, step : 1},
  zoom_alternatif_cadre_ombre_taille_pct : {min : 10, max : 300, step : 1},
  zoom_alternatif_cadre_ombre_svg_flou : {min : 0, max : 80, step : 1},
  zoom_alternatif_cadre_arrondi : {min : 0, max : 240, step : 1},
  zoom_alternatif_focus_facteur : {min : 0.2, max : 20, step : 0.1},
  zoom_alternatif_focus_offset_x : {min : -1000, max : 1000, step : 1},
  zoom_alternatif_focus_offset_y : {min : -1000, max : 1000, step : 1},
  zoom_alternatif_delai_lancement_s : {min : 0, max : 10, step : 0.1},
  zoom_alternatif_masque_fade_in_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_masque_fade_out_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_interface_fade_in_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_interface_fade_out_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_photo_fade_in_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_dezoom_offset_ms : {min : -4000, max : 4000, step : 10},
  zoom_alternatif_photo_fade_out_ms : {min : 0, max : 4000, step : 10},
  zoom_alternatif_taille_svg : {min : 0.1, max : 20, step : 0.1},
  zoom_alternatif_offset_svg : {min : -1000, max : 1000, step : 1},
  transition_scene_fade_ms : {min : 0, max : 3000, step : 10},
  morphing_image_duree_s : {min : 0.1, max : 60, step : 0.1},
  morphing_fondu_ms : {min : 0, max : 5000, step : 50},
  morphing_stage_taille_pct : {min : 5, max : 100, step : 1},
  morphing_stage_padding_rem : {min : 0, max : 8, step : 0.1},
  morphing_stage_radius_rem : {min : 0, max : 8, step : 0.1},
  morphing_ratio : {min : 0.1, max : 20, step : 0.1},
  hype_recompense_carte_taille_pct : {min : 5, max : 100, step : 1},
  hype_recompense_carte_offset_pct : {min : -100, max : 100, step : 1},
  hype_recompense_carte_disparition_ms : {min : 0, max : 30000, step : 100},
  hype_recompense_carte_fadeout_ms : {min : 0, max : 10000, step : 50},
  hype_recompense_scene_taille_pct : {min : 5, max : 100, step : 1},
  hype_recompense_scene_offset_pct : {min : -100, max : 100, step : 1},
  hype_recompense_scene_disparition_ms : {min : 0, max : 30000, step : 100},
  hype_recompense_scene_fadeout_ms : {min : 0, max : 10000, step : 50},
});

export const REGLAGES_INTERFACE_CARTE_ANIMATION_CLES = Object.freeze ([
  "zoom_carte_duree_ms",
  "delai_affichage_obj_s",
  "zoom_alternatif_delai_lancement_s",
  "zoom_alternatif_masque_fade_in_ms",
  "zoom_alternatif_masque_fade_out_ms",
  "zoom_alternatif_interface_fade_in_ms",
  "zoom_alternatif_interface_fade_out_ms",
  "zoom_alternatif_photo_fade_in_ms",
  "zoom_alternatif_dezoom_offset_ms",
  "zoom_alternatif_photo_fade_out_ms",
]);

export const REGLAGES_INTERFACE_CARTE_CADRE_CLES = Object.freeze ([
  "zoom_alternatif_cadre_epaisseur_haut",
  "zoom_alternatif_cadre_epaisseur_droite",
  "zoom_alternatif_cadre_epaisseur_bas",
  "zoom_alternatif_cadre_epaisseur_gauche",
  "zoom_alternatif_cadre_couleur",
  "zoom_alternatif_cadre_ombre_active",
  "zoom_alternatif_cadre_ombre_couleur",
  "zoom_alternatif_cadre_ombre_offset_x",
  "zoom_alternatif_cadre_ombre_offset_y",
  "zoom_alternatif_cadre_ombre_opacite",
  "zoom_alternatif_cadre_ombre_rotation",
  "zoom_alternatif_cadre_ombre_largeur_pct",
  "zoom_alternatif_cadre_ombre_hauteur_pct",
  "zoom_alternatif_cadre_ombre_arrondi",
  "zoom_alternatif_cadre_ombre_svg_active",
  "zoom_alternatif_cadre_ombre_svg_couleur",
  "zoom_alternatif_cadre_ombre_svg_offset_x",
  "zoom_alternatif_cadre_ombre_svg_offset_y",
  "zoom_alternatif_cadre_ombre_svg_opacite",
  "zoom_alternatif_cadre_ombre_svg_flou",
  "zoom_alternatif_cadre_arriere_plan_2_active",
  "zoom_alternatif_cadre_arriere_plan_2_couleur",
  "zoom_alternatif_cadre_arriere_plan_2_offset_x",
  "zoom_alternatif_cadre_arriere_plan_2_offset_y",
  "zoom_alternatif_cadre_arriere_plan_2_opacite",
  "zoom_alternatif_cadre_arriere_plan_2_rotation",
  "zoom_alternatif_cadre_arriere_plan_2_largeur_pct",
  "zoom_alternatif_cadre_arriere_plan_2_hauteur_pct",
  "zoom_alternatif_cadre_arriere_plan_2_arrondi",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_active",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_couleur",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_x",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_y",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_opacite",
  "zoom_alternatif_cadre_arriere_plan_2_ombre_svg_flou",
  "zoom_alternatif_cadre_arrondi",
  "zoom_alternatif_focus_facteur",
  "zoom_alternatif_focus_offset_x",
  "zoom_alternatif_focus_offset_y",
]);

export const REGLAGES_INTERFACE_CARTE_CONTENUS_CLES = Object.freeze ([
  "zoom_alternatif_taille_carte_jauge",
  "zoom_alternatif_taille_carte_fermeture",
  "zoom_alternatif_taille_carte_legende",
  "zoom_alternatif_taille_carte_non",
  "zoom_alternatif_taille_carte_oui",
  "zoom_alternatif_offset_x_carte_jauge",
  "zoom_alternatif_offset_y_carte_jauge",
  "zoom_alternatif_offset_x_carte_fermeture",
  "zoom_alternatif_offset_y_carte_fermeture",
  "zoom_alternatif_offset_x_carte_legende",
  "zoom_alternatif_offset_y_carte_legende",
  "zoom_alternatif_offset_x_carte_non",
  "zoom_alternatif_offset_y_carte_non",
  "zoom_alternatif_offset_x_carte_oui",
  "zoom_alternatif_offset_y_carte_oui",
  "zoom_alternatif_ancrage_carte_fermeture",
]);

export const REGLAGES_INTERFACE_CARTE_CLES = Object.freeze ([
  ...REGLAGES_INTERFACE_CARTE_CADRE_CLES,
  ...REGLAGES_INTERFACE_CARTE_CONTENUS_CLES,
]);

function borne_nombre (pValeur, pMin, pMax, pDefaut)
  {
    const tBrut = Number (pValeur);
    const tNombre = Number.isFinite (tBrut) ? tBrut : pDefaut;
    return Math.max (pMin, Math.min (pMax, tNombre));
  }

function normalise_booleen (pValeur, pDefaut)
  {
    if (pValeur === true) return true;
    if (pValeur === false) return false;
    return !!pDefaut;
  }

function normalise_couleur_hex (pValeur, pDefaut)
  {
    const tSource = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    const tBase = typeof pDefaut === "string" ? pDefaut.trim ().toLowerCase () : SURVOL_CONTOUR_DEFAUTS.couleur;
    if (/^#[0-9a-f]{6}$/.test (tSource)) return tSource;
    if (/^#[0-9a-f]{3}$/.test (tSource))
      return "#" + tSource.slice (1).split ("").map ((pCar) => pCar + pCar).join ("");
    return /^#[0-9a-f]{6}$/.test (tBase) ? tBase : SURVOL_CONTOUR_DEFAUTS.couleur;
  }

function normalise_ancrage_zoom_alternatif (pValeur, pDefaut = "droite")
  {
    const tValeur = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    if (tValeur === "gauche" || tValeur === "droite") return tValeur;
    return pDefaut === "gauche" ? "gauche" : "droite";
  }

function normalise_alignement_hype (pValeur, pDefaut = "centre", pValeurs = ["centre"])
  {
    const tValeur = typeof pValeur === "string" ? pValeur.trim ().toLowerCase () : "";
    return pValeurs.includes (tValeur) ? tValeur : pDefaut;
  }

function normalise_point_trace_jauge_visuelle (pPoint)
  {
    const tPoint = pPoint && typeof pPoint === "object" ? pPoint : {};
    const nombre = (pCle, pDefaut) =>
      {
        const tNombre = Number (tPoint[pCle]);
        return Number.isFinite (tNombre) ? Math.round (tNombre * 1000) / 1000 : pDefaut;
      };
    const tX = nombre ("x", 0);
    const tY = nombre ("y", 0);
    return {
      x : tX,
      y : tY,
      inX : nombre ("inX", tX - 18),
      inY : nombre ("inY", tY),
      outX : nombre ("outX", tX + 18),
      outY : nombre ("outY", tY),
    };
  }

function normalise_couleurs_calques_jauge_visuelle (pValeur)
  {
    const tSource = pValeur && typeof pValeur === "object" ? pValeur : {};
    const tCouleurs = {};
    const couleur = (pCouleur) =>
      {
        const tCouleur = typeof pCouleur === "string" ? pCouleur.trim ().toLowerCase () : "";
        if (/^#[0-9a-f]{6}$/.test (tCouleur)) return tCouleur;
        if (/^#[0-9a-f]{3}$/.test (tCouleur))
          return "#" + tCouleur.slice (1).split ("").map ((pCar) => pCar + pCar).join ("");
        return null;
      };
    Object.keys (tSource).forEach ((pCle) =>
      {
        const tLigne = tSource[pCle] && typeof tSource[pCle] === "object" ? tSource[pCle] : {};
        const tStart = couleur (tLigne.start);
        const tEnd = couleur (tLigne.end);
        if (tStart && tEnd) tCouleurs[pCle] = {start : tStart, end : tEnd};
      });
    return tCouleurs;
  }

function normalise_jauge_visuelle (pValeur)
  {
    const tSource = pValeur && typeof pValeur === "object" ? pValeur : null;
    if (!tSource) return null;
    const tTracePoints = Array.isArray (tSource.tracePoints)
      ? tSource.tracePoints.slice (0, 64).map (normalise_point_trace_jauge_visuelle)
      : [];
    const tLayerColors = normalise_couleurs_calques_jauge_visuelle (tSource.layerColors);
    const tResult = {};
    if (tTracePoints.length >= 2) tResult.tracePoints = tTracePoints;
    if (Object.keys (tLayerColors).length) tResult.layerColors = tLayerColors;
    return Object.keys (tResult).length ? tResult : null;
  }

function normalise_zoom_alternatif_cadre_epaisseur (pSource, pCle, pFallback)
  {
    const tBornes = REGLAGES_MODE_LECTURE_PROJET_LIMITES[pCle]
      || REGLAGES_MODE_LECTURE_PROJET_LIMITES.zoom_alternatif_cadre_epaisseur_haut;
    return Math.round (borne_nombre (
      pSource[pCle],
      tBornes.min,
      tBornes.max,
      pFallback
    ) * 10) / 10;
  }

function normalise_reglages_hype_recompense (pSource, pDefauts, pBornes, pType)
  {
    const tPrefixe = `hype_${pType}_`;
    return {
      [`${tPrefixe}fond_transparent`] : normalise_booleen (
        pSource[`${tPrefixe}fond_transparent`],
        pDefauts[`${tPrefixe}fond_transparent`]
      ),
      [`${tPrefixe}couleur_fond`] : normalise_couleur_hex (
        pSource[`${tPrefixe}couleur_fond`],
        pDefauts[`${tPrefixe}couleur_fond`]
      ),
      [`${tPrefixe}taille_pct`] : Math.round (borne_nombre (
        pSource[`${tPrefixe}taille_pct`],
        pBornes[`${tPrefixe}taille_pct`].min,
        pBornes[`${tPrefixe}taille_pct`].max,
        pDefauts[`${tPrefixe}taille_pct`]
      )),
      [`${tPrefixe}align_x`] : normalise_alignement_hype (
        pSource[`${tPrefixe}align_x`],
        pDefauts[`${tPrefixe}align_x`],
        ["gauche", "centre", "droite"]
      ),
      [`${tPrefixe}align_y`] : normalise_alignement_hype (
        pSource[`${tPrefixe}align_y`],
        pDefauts[`${tPrefixe}align_y`],
        ["haut", "centre", "bas"]
      ),
      [`${tPrefixe}offset_x_pct`] : Math.round (borne_nombre (
        pSource[`${tPrefixe}offset_x_pct`],
        pBornes[`${tPrefixe}offset_pct`].min,
        pBornes[`${tPrefixe}offset_pct`].max,
        pDefauts[`${tPrefixe}offset_x_pct`]
      )),
      [`${tPrefixe}offset_y_pct`] : Math.round (borne_nombre (
        pSource[`${tPrefixe}offset_y_pct`],
        pBornes[`${tPrefixe}offset_pct`].min,
        pBornes[`${tPrefixe}offset_pct`].max,
        pDefauts[`${tPrefixe}offset_y_pct`]
      )),
      [`${tPrefixe}disparition_ms`] : Math.round (borne_nombre (
        pSource[`${tPrefixe}disparition_ms`],
        pBornes[`${tPrefixe}disparition_ms`].min,
        pBornes[`${tPrefixe}disparition_ms`].max,
        pDefauts[`${tPrefixe}disparition_ms`]
      )),
      [`${tPrefixe}fadeout_ms`] : Math.round (borne_nombre (
        pSource[`${tPrefixe}fadeout_ms`],
        pBornes[`${tPrefixe}fadeout_ms`].min,
        pBornes[`${tPrefixe}fadeout_ms`].max,
        pDefauts[`${tPrefixe}fadeout_ms`]
      )),
    };
  }

export function normalise_reglages_mode_lecture_projet (pValeur)
  {
    const tSource = pValeur && typeof pValeur === "object"
      ? pValeur
      : {};
    const tDefauts = REGLAGES_MODE_LECTURE_PROJET_DEFAUTS;
    const tBornes = REGLAGES_MODE_LECTURE_PROJET_LIMITES;
    const tZoomCarteDelaiLegacy = Number.isFinite (Number (tSource.zoom_carte_delai_ms))
      ? Number (tSource.zoom_carte_delai_ms)
      : null;
    const tFadeMasqueLegacy = Math.round (borne_nombre (
      tSource.fade_masque_ms,
      tBornes.fade_masque_ms.min,
      tBornes.fade_masque_ms.max,
      tDefauts.fade_masque_ms
    ));
    const tCadreEpaisseurLegacy = normalise_zoom_alternatif_cadre_epaisseur (
      tSource,
      "zoom_alternatif_cadre_epaisseur",
      ZOOM_ALTERNATIF_CADRE_EPAISSEUR_DEFAUT
    );

    return {
      hover_transition_ms : Math.round (borne_nombre (
        tSource.hover_transition_ms,
        tBornes.hover_transition_ms.min,
        tBornes.hover_transition_ms.max,
        tDefauts.hover_transition_ms
      )),
      survol_obj_scale_pct : Math.round (borne_nombre (
        tSource.survol_obj_scale_pct,
        tBornes.survol_obj_scale_pct.min,
        tBornes.survol_obj_scale_pct.max,
        tDefauts.survol_obj_scale_pct
      ) * 10) / 10,
      survol_contour_couleur : normalise_couleur_hex (
        tSource.survol_contour_couleur,
        tDefauts.survol_contour_couleur
      ),
      survol_contour_epaisseur : Math.round (borne_nombre (
        tSource.survol_contour_epaisseur,
        tBornes.survol_contour_epaisseur.min,
        tBornes.survol_contour_epaisseur.max,
        tDefauts.survol_contour_epaisseur
      ) * 100) / 100,
      survol_contour_opacite : Math.round (borne_nombre (
        tSource.survol_contour_opacite,
        tBornes.survol_contour_opacite.min,
        tBornes.survol_contour_opacite.max,
        tDefauts.survol_contour_opacite
      ) * 1000) / 1000,
      nouvel_essai_contour_duree_s : Math.round (borne_nombre (
        tSource.nouvel_essai_contour_duree_s,
        tBornes.nouvel_essai_contour_duree_s.min,
        tBornes.nouvel_essai_contour_duree_s.max,
        tDefauts.nouvel_essai_contour_duree_s
      ) * 10) / 10,
      zoom_carte_zoom_delai_ms : Math.round (borne_nombre (
        tSource.zoom_carte_zoom_delai_ms,
        tBornes.zoom_carte_zoom_delai_ms.min,
        tBornes.zoom_carte_zoom_delai_ms.max,
        tZoomCarteDelaiLegacy ?? tDefauts.zoom_carte_zoom_delai_ms
      )),
      zoom_carte_dezoom_delai_ms : Math.round (borne_nombre (
        tSource.zoom_carte_dezoom_delai_ms,
        tBornes.zoom_carte_dezoom_delai_ms.min,
        tBornes.zoom_carte_dezoom_delai_ms.max,
        tZoomCarteDelaiLegacy ?? tDefauts.zoom_carte_dezoom_delai_ms
      )),
      zoom_carte_duree_ms : Math.round (borne_nombre (
        tSource.zoom_carte_duree_ms,
        tBornes.zoom_carte_duree_ms.min,
        tBornes.zoom_carte_duree_ms.max,
        tDefauts.zoom_carte_duree_ms
      )),
      delai_affichage_obj_s : Math.round (borne_nombre (
        tSource.delai_affichage_obj_s,
        tBornes.delai_affichage_obj_s.min,
        tBornes.delai_affichage_obj_s.max,
        tDefauts.delai_affichage_obj_s
      ) * 10) / 10,
      audio_general_volume_pct : Math.round (borne_nombre (
        tSource.audio_general_volume_pct,
        tBornes.audio_general_volume_pct.min,
        tBornes.audio_general_volume_pct.max,
        tSource.audio_html_volume_pct ?? tSource.audio_webaudio_volume_pct ?? tDefauts.audio_general_volume_pct
      )),
      voix_volume_pct : Math.round (borne_nombre (
        tSource.voix_volume_pct,
        tBornes.voix_volume_pct.min,
        tBornes.voix_volume_pct.max,
        tDefauts.voix_volume_pct
      )),
      fade_masque_in_ms : Math.round (borne_nombre (
        tSource.fade_masque_in_ms,
        tBornes.fade_masque_in_ms.min,
        tBornes.fade_masque_in_ms.max,
        Number.isFinite (Number (tSource.fade_masque_ms))
          ? tFadeMasqueLegacy
          : tDefauts.fade_masque_in_ms
      )),
      fade_masque_out_ms : Math.round (borne_nombre (
        tSource.fade_masque_out_ms,
        tBornes.fade_masque_out_ms.min,
        tBornes.fade_masque_out_ms.max,
        Number.isFinite (Number (tSource.fade_masque_ms))
          ? tFadeMasqueLegacy
          : tDefauts.fade_masque_out_ms
      )),
      fade_masque_ms : Math.round (borne_nombre (
        tSource.fade_masque_ms,
        tBornes.fade_masque_ms.min,
        tBornes.fade_masque_ms.max,
        Number.isFinite (Number (tSource.fade_masque_out_ms))
          ? Number (tSource.fade_masque_out_ms)
          : tDefauts.fade_masque_ms
      )),
      reveil_objet_duree_ms : Math.round (borne_nombre (
        tSource.reveil_objet_duree_ms,
        tBornes.reveil_objet_duree_ms.min,
        tBornes.reveil_objet_duree_ms.max,
        tDefauts.reveil_objet_duree_ms
      )),
      reveil_objet_scale_pct : Math.round (borne_nombre (
        tSource.reveil_objet_scale_pct,
        tBornes.reveil_objet_scale_pct.min,
        tBornes.reveil_objet_scale_pct.max,
        tDefauts.reveil_objet_scale_pct
      ) * 10) / 10,
      bulle_click_duree_ms : Math.round (borne_nombre (
        tSource.bulle_click_duree_ms,
        tBornes.bulle_click_duree_ms.min,
        tBornes.bulle_click_duree_ms.max,
        Number.isFinite (Number (tSource.fade_bulle_ms))
          ? Number (tSource.fade_bulle_ms)
          : tDefauts.bulle_click_duree_ms
      )),
      bulle_click_scale_pct : Math.round (borne_nombre (
        tSource.bulle_click_scale_pct,
        tBornes.bulle_click_scale_pct.min,
        tBornes.bulle_click_scale_pct.max,
        tDefauts.bulle_click_scale_pct
      ) * 10) / 10,
      zoom_alternatif_cadre_epaisseur_haut : normalise_zoom_alternatif_cadre_epaisseur (
        tSource,
        "zoom_alternatif_cadre_epaisseur_haut",
        tCadreEpaisseurLegacy
      ),
      zoom_alternatif_cadre_epaisseur_droite : normalise_zoom_alternatif_cadre_epaisseur (
        tSource,
        "zoom_alternatif_cadre_epaisseur_droite",
        tCadreEpaisseurLegacy
      ),
      zoom_alternatif_cadre_epaisseur_bas : normalise_zoom_alternatif_cadre_epaisseur (
        tSource,
        "zoom_alternatif_cadre_epaisseur_bas",
        tCadreEpaisseurLegacy
      ),
      zoom_alternatif_cadre_epaisseur_gauche : normalise_zoom_alternatif_cadre_epaisseur (
        tSource,
        "zoom_alternatif_cadre_epaisseur_gauche",
        tCadreEpaisseurLegacy
      ),
      zoom_alternatif_cadre_couleur : normalise_couleur_hex (
        tSource.zoom_alternatif_cadre_couleur,
        tDefauts.zoom_alternatif_cadre_couleur
      ),
      zoom_alternatif_cadre_ombre_active : normalise_booleen (
        tSource.zoom_alternatif_cadre_ombre_active,
        tDefauts.zoom_alternatif_cadre_ombre_active
      ),
      zoom_alternatif_cadre_ombre_couleur : normalise_couleur_hex (
        tSource.zoom_alternatif_cadre_ombre_couleur,
        tDefauts.zoom_alternatif_cadre_ombre_couleur
      ),
      zoom_alternatif_cadre_ombre_offset_x : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_offset_x,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_ombre_offset_x
      )),
      zoom_alternatif_cadre_ombre_offset_y : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_offset_y,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_ombre_offset_y
      )),
      zoom_alternatif_cadre_ombre_opacite : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_opacite,
        tBornes.zoom_alternatif_cadre_ombre_opacite.min,
        tBornes.zoom_alternatif_cadre_ombre_opacite.max,
        tDefauts.zoom_alternatif_cadre_ombre_opacite
      ) * 100) / 100,
      zoom_alternatif_cadre_ombre_rotation : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_rotation,
        tBornes.zoom_alternatif_cadre_ombre_rotation.min,
        tBornes.zoom_alternatif_cadre_ombre_rotation.max,
        tDefauts.zoom_alternatif_cadre_ombre_rotation
      )),
      zoom_alternatif_cadre_ombre_largeur_pct : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_largeur_pct,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.min,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.max,
        tDefauts.zoom_alternatif_cadre_ombre_largeur_pct
      )),
      zoom_alternatif_cadre_ombre_hauteur_pct : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_hauteur_pct,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.min,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.max,
        tDefauts.zoom_alternatif_cadre_ombre_hauteur_pct
      )),
      zoom_alternatif_cadre_ombre_arrondi : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_arrondi,
        tBornes.zoom_alternatif_cadre_arrondi.min,
        tBornes.zoom_alternatif_cadre_arrondi.max,
        tDefauts.zoom_alternatif_cadre_ombre_arrondi
      )),
      zoom_alternatif_cadre_ombre_svg_active : normalise_booleen (
        tSource.zoom_alternatif_cadre_ombre_svg_active,
        tDefauts.zoom_alternatif_cadre_ombre_svg_active
      ),
      zoom_alternatif_cadre_ombre_svg_couleur : normalise_couleur_hex (
        tSource.zoom_alternatif_cadre_ombre_svg_couleur,
        tDefauts.zoom_alternatif_cadre_ombre_svg_couleur
      ),
      zoom_alternatif_cadre_ombre_svg_offset_x : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_svg_offset_x,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_ombre_svg_offset_x
      )),
      zoom_alternatif_cadre_ombre_svg_offset_y : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_svg_offset_y,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_ombre_svg_offset_y
      )),
      zoom_alternatif_cadre_ombre_svg_opacite : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_svg_opacite,
        tBornes.zoom_alternatif_cadre_ombre_opacite.min,
        tBornes.zoom_alternatif_cadre_ombre_opacite.max,
        tDefauts.zoom_alternatif_cadre_ombre_svg_opacite
      ) * 100) / 100,
      zoom_alternatif_cadre_ombre_svg_flou : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_ombre_svg_flou,
        tBornes.zoom_alternatif_cadre_ombre_svg_flou.min,
        tBornes.zoom_alternatif_cadre_ombre_svg_flou.max,
        tDefauts.zoom_alternatif_cadre_ombre_svg_flou
      )),
      zoom_alternatif_cadre_arriere_plan_2_active : normalise_booleen (
        tSource.zoom_alternatif_cadre_arriere_plan_2_active,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_active
      ),
      zoom_alternatif_cadre_arriere_plan_2_couleur : normalise_couleur_hex (
        tSource.zoom_alternatif_cadre_arriere_plan_2_couleur,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_couleur
      ),
      zoom_alternatif_cadre_arriere_plan_2_offset_x : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_offset_x,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_offset_x
      )),
      zoom_alternatif_cadre_arriere_plan_2_offset_y : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_offset_y,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_offset_y
      )),
      zoom_alternatif_cadre_arriere_plan_2_opacite : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_opacite,
        tBornes.zoom_alternatif_cadre_ombre_opacite.min,
        tBornes.zoom_alternatif_cadre_ombre_opacite.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_opacite
      ) * 100) / 100,
      zoom_alternatif_cadre_arriere_plan_2_rotation : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_rotation,
        tBornes.zoom_alternatif_cadre_ombre_rotation.min,
        tBornes.zoom_alternatif_cadre_ombre_rotation.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_rotation
      )),
      zoom_alternatif_cadre_arriere_plan_2_largeur_pct : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_largeur_pct,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.min,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_largeur_pct
      )),
      zoom_alternatif_cadre_arriere_plan_2_hauteur_pct : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_hauteur_pct,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.min,
        tBornes.zoom_alternatif_cadre_ombre_taille_pct.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_hauteur_pct
      )),
      zoom_alternatif_cadre_arriere_plan_2_arrondi : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_arrondi,
        tBornes.zoom_alternatif_cadre_arrondi.min,
        tBornes.zoom_alternatif_cadre_arrondi.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_arrondi
      )),
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_active : normalise_booleen (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_active,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_active
      ),
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_couleur : normalise_couleur_hex (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_couleur,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_couleur
      ),
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_x : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_x,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_x
      )),
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_y : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_y,
        tBornes.zoom_alternatif_cadre_ombre_offset.min,
        tBornes.zoom_alternatif_cadre_ombre_offset.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_offset_y
      )),
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_opacite : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_opacite,
        tBornes.zoom_alternatif_cadre_ombre_opacite.min,
        tBornes.zoom_alternatif_cadre_ombre_opacite.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_opacite
      ) * 100) / 100,
      zoom_alternatif_cadre_arriere_plan_2_ombre_svg_flou : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_flou,
        tBornes.zoom_alternatif_cadre_ombre_svg_flou.min,
        tBornes.zoom_alternatif_cadre_ombre_svg_flou.max,
        tDefauts.zoom_alternatif_cadre_arriere_plan_2_ombre_svg_flou
      )),
      zoom_alternatif_cadre_arrondi : Math.round (borne_nombre (
        tSource.zoom_alternatif_cadre_arrondi,
        tBornes.zoom_alternatif_cadre_arrondi.min,
        tBornes.zoom_alternatif_cadre_arrondi.max,
        tDefauts.zoom_alternatif_cadre_arrondi
      )),
      zoom_alternatif_focus_facteur : Math.round (borne_nombre (
        tSource.zoom_alternatif_focus_facteur,
        tBornes.zoom_alternatif_focus_facteur.min,
        tBornes.zoom_alternatif_focus_facteur.max,
        tDefauts.zoom_alternatif_focus_facteur
      ) * 10) / 10,
      zoom_alternatif_focus_offset_x : Math.round (borne_nombre (
        tSource.zoom_alternatif_focus_offset_x,
        tBornes.zoom_alternatif_focus_offset_x.min,
        tBornes.zoom_alternatif_focus_offset_x.max,
        tDefauts.zoom_alternatif_focus_offset_x
      )),
      zoom_alternatif_focus_offset_y : Math.round (borne_nombre (
        tSource.zoom_alternatif_focus_offset_y,
        tBornes.zoom_alternatif_focus_offset_y.min,
        tBornes.zoom_alternatif_focus_offset_y.max,
        tDefauts.zoom_alternatif_focus_offset_y
      )),
      zoom_alternatif_delai_lancement_s : Math.round (borne_nombre (
        tSource.zoom_alternatif_delai_lancement_s,
        tBornes.zoom_alternatif_delai_lancement_s.min,
        tBornes.zoom_alternatif_delai_lancement_s.max,
        tDefauts.zoom_alternatif_delai_lancement_s
      ) * 10) / 10,
      zoom_alternatif_masque_fade_in_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_masque_fade_in_ms,
        tBornes.zoom_alternatif_masque_fade_in_ms.min,
        tBornes.zoom_alternatif_masque_fade_in_ms.max,
        tDefauts.zoom_alternatif_masque_fade_in_ms
      )),
      zoom_alternatif_masque_fade_out_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_masque_fade_out_ms,
        tBornes.zoom_alternatif_masque_fade_out_ms.min,
        tBornes.zoom_alternatif_masque_fade_out_ms.max,
        tDefauts.zoom_alternatif_masque_fade_out_ms
      )),
      zoom_alternatif_interface_fade_in_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_interface_fade_in_ms,
        tBornes.zoom_alternatif_interface_fade_in_ms.min,
        tBornes.zoom_alternatif_interface_fade_in_ms.max,
        tDefauts.zoom_alternatif_interface_fade_in_ms
      )),
      zoom_alternatif_interface_fade_out_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_interface_fade_out_ms,
        tBornes.zoom_alternatif_interface_fade_out_ms.min,
        tBornes.zoom_alternatif_interface_fade_out_ms.max,
        tDefauts.zoom_alternatif_interface_fade_out_ms
      )),
      zoom_alternatif_photo_fade_in_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_photo_fade_in_ms,
        tBornes.zoom_alternatif_photo_fade_in_ms.min,
        tBornes.zoom_alternatif_photo_fade_in_ms.max,
        tDefauts.zoom_alternatif_photo_fade_in_ms
      )),
      zoom_alternatif_dezoom_offset_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_dezoom_offset_ms,
        tBornes.zoom_alternatif_dezoom_offset_ms.min,
        tBornes.zoom_alternatif_dezoom_offset_ms.max,
        tDefauts.zoom_alternatif_dezoom_offset_ms
      )),
      zoom_alternatif_photo_fade_out_ms : Math.round (borne_nombre (
        tSource.zoom_alternatif_photo_fade_out_ms,
        tBornes.zoom_alternatif_photo_fade_out_ms.min,
        tBornes.zoom_alternatif_photo_fade_out_ms.max,
        tDefauts.zoom_alternatif_photo_fade_out_ms
      )),
      zoom_alternatif_taille_carte_jauge : Math.round (borne_nombre (
        tSource.zoom_alternatif_taille_carte_jauge,
        tBornes.zoom_alternatif_taille_svg.min,
        tBornes.zoom_alternatif_taille_svg.max,
        tDefauts.zoom_alternatif_taille_carte_jauge
      ) * 10) / 10,
      zoom_alternatif_taille_carte_fermeture : Math.round (borne_nombre (
        tSource.zoom_alternatif_taille_carte_fermeture,
        tBornes.zoom_alternatif_taille_svg.min,
        tBornes.zoom_alternatif_taille_svg.max,
        tDefauts.zoom_alternatif_taille_carte_fermeture
      ) * 10) / 10,
      zoom_alternatif_taille_carte_legende : Math.round (borne_nombre (
        tSource.zoom_alternatif_taille_carte_legende,
        tBornes.zoom_alternatif_taille_svg.min,
        tBornes.zoom_alternatif_taille_svg.max,
        tDefauts.zoom_alternatif_taille_carte_legende
      ) * 10) / 10,
      zoom_alternatif_taille_carte_non : Math.round (borne_nombre (
        tSource.zoom_alternatif_taille_carte_non,
        tBornes.zoom_alternatif_taille_svg.min,
        tBornes.zoom_alternatif_taille_svg.max,
        tDefauts.zoom_alternatif_taille_carte_non
      ) * 10) / 10,
      zoom_alternatif_taille_carte_oui : Math.round (borne_nombre (
        tSource.zoom_alternatif_taille_carte_oui,
        tBornes.zoom_alternatif_taille_svg.min,
        tBornes.zoom_alternatif_taille_svg.max,
        tDefauts.zoom_alternatif_taille_carte_oui
      ) * 10) / 10,
      boutons_scene_taille_carte_jauge_pct : Math.round (borne_nombre (
        tSource.boutons_scene_taille_carte_jauge_pct,
        25,
        400,
        tDefauts.boutons_scene_taille_carte_jauge_pct
      )),
      boutons_scene_offset_x_carte_jauge : Math.round (borne_nombre (
        tSource.boutons_scene_offset_x_carte_jauge,
        -1000,
        1000,
        tDefauts.boutons_scene_offset_x_carte_jauge
      )),
      boutons_scene_offset_y_carte_jauge : Math.round (borne_nombre (
        tSource.boutons_scene_offset_y_carte_jauge,
        -1000,
        1000,
        tDefauts.boutons_scene_offset_y_carte_jauge
      )),
      zoom_alternatif_offset_x_carte_jauge : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_x_carte_jauge,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_x_carte_jauge
      )),
      zoom_alternatif_offset_y_carte_jauge : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_y_carte_jauge,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_y_carte_jauge
      )),
      zoom_alternatif_offset_x_carte_fermeture : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_x_carte_fermeture,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_x_carte_fermeture
      )),
      zoom_alternatif_offset_y_carte_fermeture : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_y_carte_fermeture,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_y_carte_fermeture
      )),
      zoom_alternatif_offset_x_carte_legende : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_x_carte_legende,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_x_carte_legende
      )),
      zoom_alternatif_offset_y_carte_legende : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_y_carte_legende,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_y_carte_legende
      )),
      zoom_alternatif_offset_x_carte_non : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_x_carte_non,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_x_carte_non
      )),
      zoom_alternatif_offset_y_carte_non : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_y_carte_non,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_y_carte_non
      )),
      zoom_alternatif_offset_x_carte_oui : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_x_carte_oui,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_x_carte_oui
      )),
      zoom_alternatif_offset_y_carte_oui : Math.round (borne_nombre (
        tSource.zoom_alternatif_offset_y_carte_oui,
        tBornes.zoom_alternatif_offset_svg.min,
        tBornes.zoom_alternatif_offset_svg.max,
        tDefauts.zoom_alternatif_offset_y_carte_oui
      )),
      zoom_alternatif_ancrage_carte_fermeture : normalise_ancrage_zoom_alternatif (
        tSource.zoom_alternatif_ancrage_carte_fermeture,
        tDefauts.zoom_alternatif_ancrage_carte_fermeture
      ),
      transition_scene_fade_ms : Math.round (borne_nombre (
        tSource.transition_scene_fade_ms,
        tBornes.transition_scene_fade_ms.min,
        tBornes.transition_scene_fade_ms.max,
        tDefauts.transition_scene_fade_ms
      )),
      morphing_image_duree_s : Math.round (borne_nombre (
        tSource.morphing_image_duree_s,
        tBornes.morphing_image_duree_s.min,
        tBornes.morphing_image_duree_s.max,
        tDefauts.morphing_image_duree_s
      ) * 10) / 10,
      morphing_fondu_ms : Math.round (borne_nombre (
        tSource.morphing_fondu_ms,
        tBornes.morphing_fondu_ms.min,
        tBornes.morphing_fondu_ms.max,
        tDefauts.morphing_fondu_ms
      )),
      morphing_fond_couleur : normalise_couleur_hex (
        tSource.morphing_fond_couleur,
        tDefauts.morphing_fond_couleur
      ),
      morphing_stage_taille_pct : Math.round (borne_nombre (
        tSource.morphing_stage_taille_pct,
        tBornes.morphing_stage_taille_pct.min,
        tBornes.morphing_stage_taille_pct.max,
        tDefauts.morphing_stage_taille_pct
      )),
      morphing_stage_padding_rem : Math.round (borne_nombre (
        tSource.morphing_stage_padding_rem,
        tBornes.morphing_stage_padding_rem.min,
        tBornes.morphing_stage_padding_rem.max,
        tDefauts.morphing_stage_padding_rem
      ) * 10) / 10,
      morphing_stage_radius_rem : Math.round (borne_nombre (
        tSource.morphing_stage_radius_rem,
        tBornes.morphing_stage_radius_rem.min,
        tBornes.morphing_stage_radius_rem.max,
        tDefauts.morphing_stage_radius_rem
      ) * 10) / 10,
      morphing_ratio_l : Math.round (borne_nombre (
        tSource.morphing_ratio_l,
        tBornes.morphing_ratio.min,
        tBornes.morphing_ratio.max,
        tDefauts.morphing_ratio_l
      ) * 10) / 10,
      morphing_ratio_h : Math.round (borne_nombre (
        tSource.morphing_ratio_h,
        tBornes.morphing_ratio.min,
        tBornes.morphing_ratio.max,
        tDefauts.morphing_ratio_h
      ) * 10) / 10,
      morphing_bouton_ratio_l : Math.round (borne_nombre (
        tSource.morphing_bouton_ratio_l,
        tBornes.morphing_ratio.min,
        tBornes.morphing_ratio.max,
        tDefauts.morphing_bouton_ratio_l
      ) * 10) / 10,
      morphing_bouton_ratio_h : Math.round (borne_nombre (
        tSource.morphing_bouton_ratio_h,
        tBornes.morphing_ratio.min,
        tBornes.morphing_ratio.max,
        tDefauts.morphing_bouton_ratio_h
      ) * 10) / 10,
      animation_30fps_actif : normalise_booleen (
        tSource.animation_30fps_actif,
        tDefauts.animation_30fps_actif
      ),
      jauge_visuelle : normalise_jauge_visuelle (tSource.jauge_visuelle),
      ...normalise_reglages_hype_recompense (tSource, tDefauts, tBornes, "recompense_carte"),
      ...normalise_reglages_hype_recompense (tSource, tDefauts, tBornes, "recompense_scene"),
    };
  }

export function extrait_reglages_interface_carte (pValeur, pFallback = null)
  {
    const tSource = pValeur && typeof pValeur === "object" ? pValeur : {};
    const tBase = pFallback && typeof pFallback === "object"
      ? {...pFallback, ...tSource}
      : tSource;
    const tNormalises = normalise_reglages_mode_lecture_projet (tBase);
    const tResultat = {};
    REGLAGES_INTERFACE_CARTE_CLES.forEach ((pCle) =>
      {
        tResultat[pCle] = tNormalises[pCle];
      });
    return tResultat;
  }
